// extracted by mini-css-extract-plugin
export default {"theme_shimmer":"#e0e0e0","theme_shimmer_bg":"#f0f0f0","theme_shimmer_leads":"#1e232d"};